import reactStyled from 'styled-components'

// Images
import schedule from '../../lib/assets/icons/schedulePatients.svg'

// Constants
import { Constants } from '@sukiai/components'

const { ICON_SIZE } = Constants

export const ScheduleIcon = reactStyled.img.attrs({
  src: schedule
})`
    height: ${ICON_SIZE.SMALL}px;
    width: ${ICON_SIZE.SMALL}px;
    position: relative;
    bottom: -5px;
  `
